import React, { useState , useEffect } from 'react';
import Header from '../components/header';

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    document.title = "ระบบแจ้งซ่อมพนักงาน - เข้าสู่ระบบ";
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true); // ตั้งค่าการโหลดเป็น true
  
    // แสดง spinner ก่อนเริ่มการโหลด
    const loader = document.querySelector('.loader');
    if (loader) {
      loader.style.display = 'flex'; // แสดง spinner
    }
  
    // ส่งข้อมูลไปยัง API PHP
    // const domain = 'cdn.jobsallow.site';
    // const domain = 'software.piyamanee.com';
    const domain = "software.piyamanee.com";
    const response = await fetch(`https://${domain}/server/loginData/login.php`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        username: username,
        password: password,
      }),
    });
  
    const data = await response.json();
    setIsLoading(false); // ตั้งค่าการโหลดเป็น false เมื่อการโหลดเสร็จสิ้น
  
    if (loader) {
      loader.style.display = 'none';
    }
  
    // ตรวจสอบว่าเข้าสู่ระบบสำเร็จหรือไม่
    if (data.status === 'success') {
      // หาก status เป็น success แต่ไม่มีข้อมูล user (จากที่ API ตอบกลับไม่มี data.user)
      localStorage.setItem('user', JSON.stringify({ name: username })); // บันทึกชื่อผู้ใช้ลง localStorage
      loader.style.display = 'flex';
  
      setTimeout(() => {
        window.location.href = '/repair';
      }, 2000);
  
    } else {
      // หากข้อมูลไม่ถูกต้อง
      const errorMessage = document.querySelector('.alertInfo');
      if (errorMessage) {
        errorMessage.innerHTML = '<i class="fa-solid fa-triangle-exclamation"></i> ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง';
        errorMessage.style.display = 'block';
      }
    }
  };   

  return (
    <div>
      <Header />
      <div className="LoginContainer">
        <div className="LoginBody">
          <h5><i className="fa-solid fa-user-tie"></i> เข้าสู่ระบบ - สำหรับแอดมิน</h5>
          <div className="LoginInputContainer" style={{ marginBottom: "0px" }}>
            <div className="mb-3">
              <p style={{ marginBottom: "5px", color: "gray" }}>Username</p>
              <input
                type="text"
                placeholder="ชื่อผู้ใช้"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </div>
          </div>
          <div className="LoginInputContainer" style={{ marginBottom: "0px" }}>
            <div className="mb-3">
              <p style={{ marginBottom: "5px", color: "gray" }}>Password</p>
              <input
                type="password"
                placeholder="รหัสผ่าน"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
          </div>
          <div className="LoginButtonContainer">
            <button className="LoginButtonPrimary" onClick={handleLogin} disabled={isLoading}>
              {isLoading ? (
                <i className="fa fa-spinner fa-spin"></i> // Spinner Icon
              ) : (
                <i className="fa-solid fa-right-from-bracket"></i> // Icon เมื่อไม่ได้โหลด
              )}
              {isLoading ? ' กำลังเข้าสู่ระบบ...' : ' Sign in'}
            </button>
          </div>
        </div>
      </div>
      <div className="alertInfo"></div>
      <div className="LoginInfo">
        <span><i className="fa-solid fa-circle-info"></i> Username และ Password สามารถขอได้จากผู้พัฒนาเท่านั้น </span>
      </div>

      <div className="loader" style={{display: "none"}}>
        <div className="spinner"></div>
      </div>

    </div>
    
  );
}

export default Login;